module.exports = __webpack_public_path__ + "static/media/JW-marriot06.9382d22c.jpg";